module.exports = __webpack_public_path__ + "Assets/60cae32f-adbc-4849-a2a7-51f8148b3332.woff2";